<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row class="mt-3">
        <b-col>
          <b-button variant="link" @click="$router.push('/loyalty/benefits')">&larr; Beneficios</b-button>
          <h1>{{ form.id ? 'Editar beneficio' : 'Nuevo beneficio' }}</h1>
        </b-col>
      </b-row>

      <b-tabs content-class="mt-3">
        <b-tab title="1. Identidad" active>
          <b-form-group label="Código"><b-form-input v-model="form.code"></b-form-input></b-form-group>
          <b-form-group label="Nombre"><b-form-input v-model="form.name"></b-form-input></b-form-group>
          <b-form-group label="Descripción / T&C"><b-form-textarea v-model="form.description" rows="2"></b-form-textarea></b-form-group>
          <b-form-checkbox v-model="form.active" switch>Activo</b-form-checkbox>
          <b-row>
            <b-col><b-form-group label="Vigente desde"><b-form-input v-model="form.starts_at" placeholder="YYYY-MM-DD HH:MM:SS"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Vigente hasta"><b-form-input v-model="form.ends_at" placeholder="YYYY-MM-DD HH:MM:SS"></b-form-input></b-form-group></b-col>
          </b-row>
        </b-tab>

        <b-tab title="2. Efecto">
          <b-form-group label="Tipo de efecto">
            <b-form-select v-model="form.effect_type" :options="effectOptions"></b-form-select>
          </b-form-group>
          <b-form-group label="Valor (monto, % o tasa; para free_shipping = descuento flat en pesos)">
            <b-form-input type="number" step="0.01" v-model.number="form.effect_value"></b-form-input>
          </b-form-group>
          <b-row>
            <b-col><b-form-group label="Tope de descuento"><b-form-input type="number" step="0.01" v-model.number="form.effect_max_amount"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Cantidad (free_product)"><b-form-input type="number" step="0.01" v-model.number="form.effect_qty"></b-form-input></b-form-group></b-col>
          </b-row>
          <b-row>
            <b-col><b-form-group label="Producto (id)"><b-form-input type="number" v-model.number="form.effect_product_id"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Grupo de producto (id)"><b-form-input type="number" v-model.number="form.effect_product_group_id"></b-form-input></b-form-group></b-col>
          </b-row>
          <b-form-group label="Excluir productos con flag (coma)"><b-form-input v-model="ui.excludedFlags" placeholder="benefit_excluded"></b-form-input></b-form-group>
        </b-tab>

        <b-tab title="3. Condiciones">
          <b-form-group label="Mínimo de compra"><b-form-input type="number" step="0.01" v-model.number="form.min_subtotal"></b-form-input></b-form-group>
          <b-form-group label="Canales (coma: app,pos)"><b-form-input v-model="ui.channels"></b-form-input></b-form-group>
          <b-form-group label="Modalidades (coma: delivery,dinein)"><b-form-input v-model="ui.fulfillments"></b-form-input></b-form-group>
          <b-form-group label="Días de la semana (coma, 1=lun..7=dom)"><b-form-input v-model="ui.weekdays"></b-form-input></b-form-group>
          <b-row>
            <b-col><b-form-group label="Nivel requerido (id)"><b-form-input type="number" v-model.number="form.requires_tier_id"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Coincidencia de nivel"><b-form-select v-model="form.tier_match" :options="['min','exact']"></b-form-select></b-form-group></b-col>
            <b-col><b-form-group label="Nivel máximo (id)"><b-form-input type="number" v-model.number="form.max_tier_id"></b-form-input></b-form-group></b-col>
          </b-row>
          <b-form-checkbox v-model="form.stackable" switch>Acumulable</b-form-checkbox>
          <b-form-checkbox v-model="form.points_on_remainder" switch>Genera puntos sobre el resto pagado</b-form-checkbox>
          <b-form-checkbox v-model="form.auto_apply" switch>Aplicación automática</b-form-checkbox>
          <b-form-checkbox v-model="form.requires_code" switch>Requiere código</b-form-checkbox>
        </b-tab>

        <b-tab title="4. Emisión">
          <b-form-group label="Disparador">
            <b-form-select v-model="form.trigger_type" :options="triggerOptions"></b-form-select>
          </b-form-group>
          <b-form-group label="Parámetros del disparador (JSON)"><b-form-input v-model="ui.triggerConfig" placeholder='{"n":5} o {"first_n":1000} o {"issue_qty":2}'></b-form-input></b-form-group>
          <b-row>
            <b-col><b-form-group label="Modo de vigencia"><b-form-select v-model="form.validity_mode" :options="validityOptions"></b-form-select></b-form-group></b-col>
            <b-col><b-form-group label="Días de vigencia"><b-form-input type="number" v-model.number="form.validity_days"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Vence (fixed)"><b-form-input v-model="form.valid_until" placeholder="YYYY-MM-DD HH:MM:SS"></b-form-input></b-form-group></b-col>
          </b-row>
          <b-form-group label="Usos por emisión"><b-form-input type="number" v-model.number="form.max_uses_per_issue"></b-form-input></b-form-group>
        </b-tab>

        <b-tab title="5. Simulador">
          <p class="text-muted">Evalúa el beneficio (dry_run) contra un carrito de prueba.</p>
          <b-row>
            <b-col><b-form-group label="Cliente (id)"><b-form-input type="number" v-model.number="sim.customer_id"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Canal"><b-form-input v-model="sim.channel_code"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Día (1-7)"><b-form-input type="number" v-model.number="sim.weekday"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Subtotal"><b-form-input type="number" step="0.01" v-model.number="sim.subtotal"></b-form-input></b-form-group></b-col>
          </b-row>
          <b-row>
            <b-col><b-form-group label="Producto (id)"><b-form-input type="number" v-model.number="sim.product_id"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Grupo (id)"><b-form-input type="number" v-model.number="sim.group_id"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Cantidad"><b-form-input type="number" v-model.number="sim.qty"></b-form-input></b-form-group></b-col>
            <b-col><b-form-group label="Precio unit."><b-form-input type="number" step="0.01" v-model.number="sim.unit_price"></b-form-input></b-form-group></b-col>
          </b-row>
          <b-button variant="info" @click="simulate">¿Aplica?</b-button>
          <div v-if="simResult" class="mt-3">
            <h6>Aplicables</h6>
            <pre>{{ JSON.stringify(simResult.applicable, null, 2) }}</pre>
            <h6>Rechazados</h6>
            <pre>{{ JSON.stringify(simResult.rejected, null, 2) }}</pre>
          </div>
        </b-tab>
      </b-tabs>

      <b-row class="mt-3">
        <b-col><b-button variant="primary" @click="save">Guardar</b-button></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import benefitsService from "../../services/benefitsService";

export default {
  name: "beneficio",
  components: { Nav },
  data() {
    return {
      form: this.blankForm(),
      ui: { channels: "", fulfillments: "", weekdays: "", excludedFlags: "", triggerConfig: "" },
      sim: { customer_id: null, channel_code: "pos", weekday: null, subtotal: 0, product_id: null, group_id: null, qty: 1, unit_price: 0 },
      simResult: null,
      effectOptions: ["amount_off", "percent_off", "free_product", "bogo", "free_shipping", "cashback_boost", "credit"],
      triggerOptions: ["manual", "registration", "qr_registration", "tier_monthly", "tier_upgrade", "birthday", "app_anniversary", "nth_order_month", "referral_referrer", "referral_referred", "launch_cohort", "first_purchase"],
      validityOptions: ["days", "end_of_month", "end_of_birth_month", "fixed"],
    };
  },
  mounted() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
  methods: {
    blankForm() {
      return {
        id: 0, code: "", name: "", description: "", active: true, starts_at: "", ends_at: "",
        effect_type: "amount_off", effect_value: 0, effect_max_amount: null, effect_qty: null,
        effect_product_id: null, effect_product_group_id: null, min_subtotal: null,
        requires_tier_id: null, tier_match: "min", max_tier_id: null,
        stackable: false, points_on_remainder: false, auto_apply: false, requires_code: false,
        generates_points: false, trigger_type: "manual", validity_mode: "days", validity_days: null,
        valid_until: "", max_uses_per_issue: 1,
      };
    },
    load(id) {
      benefitsService.listDefinitions().then((res) => {
        const def = (res.data || []).find((d) => String(d.id) === String(id));
        if (!def) return;
        this.form = { ...this.blankForm(), ...def };
        this.ui.channels = this.parseArr(def.applies_channels).join(",");
        this.ui.fulfillments = this.parseArr(def.applies_fulfillments).join(",");
        this.ui.weekdays = this.parseArr(def.weekdays).join(",");
        this.ui.excludedFlags = this.parseArr(def.excluded_product_flags).join(",");
        this.ui.triggerConfig = this.strOf(def.trigger_config);
      }).catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    parseArr(v) {
      const s = this.strOf(v);
      if (!s) return [];
      try { const a = JSON.parse(s); return Array.isArray(a) ? a : []; } catch (e) { return []; }
    },
    strOf(v) {
      if (v === null || v === undefined) return "";
      if (typeof v === "string") return v;
      if (v.String !== undefined) return v.Valid ? v.String : "";
      return JSON.stringify(v);
    },
    buildPayload() {
      const p = { ...this.form };
      const csvToJson = (csv, numeric) => {
        const parts = csv.split(",").map((s) => s.trim()).filter(Boolean);
        if (!parts.length) return null;
        return JSON.stringify(numeric ? parts.map((x) => parseInt(x, 10)) : parts);
      };
      p.applies_channels = csvToJson(this.ui.channels, false);
      p.applies_fulfillments = csvToJson(this.ui.fulfillments, false);
      p.weekdays = csvToJson(this.ui.weekdays, true);
      p.excluded_product_flags = csvToJson(this.ui.excludedFlags, false);
      p.trigger_config = this.ui.triggerConfig ? this.ui.triggerConfig : null;
      return p;
    },
    save() {
      const payload = this.buildPayload();
      const req = this.form.id ? benefitsService.updateDefinition(this.form.id, payload) : benefitsService.createDefinition(payload);
      req.then((res) => {
        this.makeToast("Guardado", "Beneficio guardado", "success");
        if (!this.form.id && res.data && res.data.id) this.$router.replace("/loyalty/benefit/" + res.data.id);
      }).catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    simulate() {
      const payload = {
        customer_id: this.sim.customer_id, channel_code: this.sim.channel_code,
        weekday: this.sim.weekday || null, subtotal: this.sim.subtotal, dry_run: true,
        lines: [{ line_ref: "L1", product_id: this.sim.product_id, group_id: this.sim.group_id, qty: this.sim.qty, unit_price: this.sim.unit_price }],
      };
      benefitsService.evaluate(payload)
        .then((res) => { this.simResult = res.data; })
        .catch((err) => this.makeToast("Error", this.errMsg(err), "danger"));
    },
    errMsg(err) {
      if (err && err.response && err.response.data) {
        return typeof err.response.data === "string" ? err.response.data : (err.response.data.error || JSON.stringify(err.response.data));
      }
      return err && err.message ? err.message : "Error desconocido";
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>
